<template>
	<v-container class="content" fluid>
		<h1 class="display-1 px-3">Einpressungen</h1>

		<v-tabs slider-color="accent">
			<v-tab v-for="category of categories" :key="category.value">
				{{ category.text }}
			</v-tab>
			<v-tab-item v-for="category of categories" :key="category.value">
				<v-data-table
					style="table-layout: fixed"
					:headers="positionHeader"
					:items="getCategoryForms(category.value)"
					:loading="loading"
					hide-actions
					class="elevation-1"
				>
					<template slot="items" slot-scope="form">
						<tr>
							<td>
								<cad-preview
									:articleId="form.item.toolId"
									width="60px"
									height="60px"
									:readonly="true"
								></cad-preview>
							</td>
							<td>{{ form.item.toolName }}</td>
							<td>{{ form.item.supplierArticleId }}</td>
							<td>
								<v-text-field
									v-model="form.item.fertigerName"
									hint="Das erscheint auf dem Fertigungsdokument"
									:disabled="!canManageAvailability"
									@change="
										() => {
											form.item.fertigerName = form.item.fertigerName.trim();
											setAvailability(form.item);
										}
									"
								></v-text-field>
							</td>
							<td>
								<v-text-field
									v-model="form.item.fertigerText"
									hint="Wird aktuell nicht verwendet. Muss aber etwas enthalten, damit die Einpressung als Verfügbar gekennzeichnet ist."
									:disabled="!canManageAvailability"
									@change="
										() => {
											form.item.fertigerText = form.item.fertigerText.trim();
											setAvailability(form.item);
										}
									"
								></v-text-field>
							</td>
							<td class="text-xs-left">
								<download-cad-component
									:translate="false"
									:articleId="form.item.toolId"
									:name="form.item.toolName + '.scdoc'"
								></download-cad-component>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-tab-item>
		</v-tabs>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import PressJoinCategory from "../dtos/pressJoinCategory";
import CadPreview from "./cadPreviewComponent.vue";
import DownloadCadComponent from "./downloadCadComponent.vue";

export default {
	components: {
		"cad-preview": CadPreview,
		"download-cad-component": DownloadCadComponent,
	},

	data() {
		return {
			loading: false,
			templates: [],
			categories: [
				{
					value: PressJoinCategory.SelfClinchingNuts,
					text: "Einpressmuttern",
				},
				{
					value: PressJoinCategory.SelfClinchingThreadedStud,
					text: "Einpressgewindebolzen",
				},
				{
					value: PressJoinCategory.SelfClinchingThreadedStandoff,
					text: "Einpressgewindebuchsen",
				},
			],
			positionHeader: [
				{
					text: "Vorschau",
					sortable: false,
					align: "left",
					width: "60px",
				},
				{
					text: "Einpressartikel Bezeichnung",
					align: "left",
					sortable: true,
					value: "toolName",
					width: "250px",
				},
				{
					text: "Bossard Bestellnummer",
					align: "left",
					sortable: true,
					value: "supplierArticleId",
					width: "60px",
				},
				{
					text: "Fertiger Bezeichnung oder ERP Artikel Id",
					align: "left",
					sortable: false,
					value: "fertigername",
				},
				{
					text: "Artikel Id in Boost",
					align: "left",
					sortable: false,
					value: "fertigerText",
				},
			],
		};
	},

	mounted() {
		this.loadTemplates();
	},

	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
	},

	methods: {
		canManageAvailability() {
			// this is true if the user is an admin and false otherwise
			return this.fertiger.canManuallyTransmit;
		},
		getCategoryForms(category) {
			return this.templates.filter((t) => t.category == category);
		},

		async loadTemplates() {
			try {
				this.loading = true;
				const response = await httpClient().get(
					`api/Material/GetPressJoinFormTemplates?fertigerId=${this.fertiger.id}`
				);
				console.log(response);
				this.templates = response.data;
			} catch (err) {
				console.log("Loading of templates failed.");
			} finally {
				this.loading = false;
			}
		},

		async setAvailability(template) {
			try {
				this.loading = true;
				const toolMap = {
					stanzwerkzeugId: template.toolId,
					fertigerName: template.fertigerName,
					fertigerText: template.fertigerText,
				};
				await httpClient().post(
					`api/Material/UpdateToolMap?fertigerId=${this.fertiger.id}`,
					toolMap
				);
			} catch (err) {
				console.log("Failed to change availability.");
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
